import * as React from 'react';
import { Chip, Tooltip } from '@material-ui/core';
import { ChipProps } from '@material-ui/core/Chip';
import { TooltipProps } from '@material-ui/core/Tooltip';

import { QRLabelMapJSON } from '../../Quantification/QuantificationResultJSON';
import NodeLabel from './NodeLabel';

export interface NodeLabelChipProps extends ChipProps {
  map?: QRLabelMapJSON;
  name?: string;
  tooltipProps?: TooltipProps;
  nodeLabel?: NodeLabel;
}

export default class NodeLabelChip extends React.Component<NodeLabelChipProps> {
  private readonly text: string;

  private readonly tooltip: string;

  constructor(props: NodeLabelChipProps) {
    super(props);
    const { map, name, nodeLabel } = props;
    try {
      const nLabel: NodeLabel = nodeLabel || NodeLabel.buildWithDefaults(map, name);
      const label = nLabel.getLabel();
      this.text = label.getName();
      this.tooltip = label.getDescription();
    } catch (e) {
      this.text = '';
      this.tooltip = '';
    }
  }

  render(): JSX.Element {
    const { tooltipProps, ...others } = this.props;
    return (
      <Tooltip {...tooltipProps} title={this.tooltip}>
        <Chip
          label={this.text}
          variant="outlined"
          color="primary"
          {...others}
        />
      </Tooltip>
    );
  }
}
